import { Box, Button, Divider, Grid, Paper, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { announcementNavigation, announcementNavigationMobile } from '../utility/navigations';
import { cloneElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAnnouncementStatus, selectEventsStatus, selectGnnStatus } from '../../Auth/authSlice';
import { Can } from '../../../context/Ability';
import { variants } from '../../../variants/variants';
import CopyrightNotice from '../../../pages/copyRights';
import MeetTheDevs from './MeetTheDevs';
import { AdminPanelSettings, AdminPanelSettingsOutlined, ChatBubbleOutlineOutlined } from '@mui/icons-material';

const AnnouncementsTab = ({ handleClick }) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const active = pathname.split('/')[3];
  const isSm = useMediaQuery(theme.breakpoints.down('lg')); 
  let navigationList = isSm ? announcementNavigationMobile : announcementNavigation 
  const unreadStatuses = {
    board: useSelector(selectAnnouncementStatus),
    gnn: useSelector(selectGnnStatus),
    leave: useSelector(selectEventsStatus),
  };

  return (
    <Box
      component={Paper}
      elevation={0}
      sx={{
        // backgroundColor: variants.boxBackground.PROFILE_CARD,
        backgroundColor: variants.boxBackground.PROFILE_CARD,
        // linear-gradient(to bottom right, red, yellow);

        p: 1,
        borderRadius: '10px 10px 0 0',
        bottom: 0,
        height: '100%',
        maxHeight: '90px',
        position: 'sticky',
        border: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',

        [theme.breakpoints.down('lg')]: {
          maxHeight: '72px',
          bottom: '-1px',
        },
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent={'space-around'} sx={{ marginTop: '5px' }}>
        {navigationList.map((nav, index) => (
          // <Can key={index} I="read" a={nav.feature}>
          <Tooltip title={nav.tooltip} key={index}>
            <>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Button
                  id={nav.path}
                  onClick={() => handleClick(nav)}
                  disableRipple
                  sx={{ borderRadius: '50%', width: '1rem', height: '0.6rem', minWidth: 'inherit' }}
                >
                  {cloneElement(nav.icon, {
                    sx: { fontSize: '1.5rem', color: active == nav.path ? '#0A4FAC' : 'black' },
                  })}
                  {unreadStatuses[nav.path] && active !== nav.path && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -10,
                        right: -15,
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: 'green',
                      }}
                    />
                  )}
                </Button>

                <Typography sx={{ fontSize: 12, color: active == nav.path ? '#0A4FAC' : 'black' }}>
                  {nav.title}
                </Typography>
              </Grid>
            </>
          </Tooltip>
          // </Can>
        ))}
        <Can I='read' a='Admin'>
          <Divider orientation='vertical' flexItem sx={{ mx: 0, height: '50px' }} />
          <Tooltip title='Admin Panel'>
            <Grid
              sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 1 }}
            >
              <Button
                onClick={() => handleClick({ path: 'admin', title: 'Admin', icon: <AdminPanelSettingsOutlined /> })}
                disableRipple
                sx={{ borderRadius: '50%', width: '1rem', height: '0.6rem' }}
              >
                <AdminPanelSettingsOutlined
                  sx={{ fontSize: '1.5rem', color: active == 'admin' ? '#0A4FAC' : 'black' }}
                />
              </Button>
              <Typography sx={{ fontSize: 12, color: active == 'admin' ? '#0A4FAC' : 'black' }}>Admin</Typography>
            </Grid>
          </Tooltip>
        </Can>
      </Stack>
      {/* <Typography >Powered by Linkway. Copyrights @2024.</Typography> */}
      <Stack
        sx={{
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        }}
      >
        <CopyrightNotice />
      </Stack>
    </Box>
  );
};

export default AnnouncementsTab;
